import React from 'react';
import PIXI from 'pixi.js/src';

import renderHelper from './../helpers/render';
import './../../vendor/greensock-js/src/uncompressed/TweenLite.js';


const EmojiRotator = React.createClass({
  /**
   * Used by React as the component name
   */
  displayName: 'EmojiRotator',


  /**
   * Emojis to rotate
   */
  emojis: ['🔥', '🏀', '👀', '🙌', '💯', '😂', '👏', '🏆'],


  /**
   * Holds the emoji objects
   */
  emojiObjects: [],


  /**
   * Interval to change emojis
   */
  changeInterval: 0,


  /**
   * Timeout to re-lay everything out
   */
  resetTimeout: 0,


  /**
   * Expected propTypes
   * @prop {Boolean} active - If the animation should be performed
   * @prop {Object} cssTransforms3d - Whether the browser
   * supports css 3d transforms
   * @prop {Boolean} large - If the user is viewing the large experience
   * @prop {Boolean} active - If the animation is paused
   * @prop {Number} startDelay - The delay before starting the animation
   */
  propTypes: {
    active: React.PropTypes.bool,
    cssTransforms3d: React.PropTypes.bool,
    large: React.PropTypes.bool.isRequired,
    paused: React.PropTypes.bool,
    startDelay: React.PropTypes.number,
  },


  /**
   * Get initial state object
   * @returns {Object} initial state
   */
  getInitialState() {
    return {
      currentEmoji: this.emojis[0],
      transitionOut: false,
    };
  },


  /**
   * Sets everything up
   * @returns {undefined} undefined
   */
  componentDidMount() {
    const appContainer = this.refs.rotatorContainer;
    window.addEventListener('resize', this._onResize);

    renderHelper.init(appContainer);

    this.resetTimeout = setTimeout(() => {
      this._setup();
    }, 20);
  },


  /**
   * Called before component is removed from the DOM
   * @returns {undefined} undefined
   */
  componentWillUnmount() {
    clearTimeout(this.resetTimeout);

    this._removeContent();
    renderHelper.destroy();

    window.removeEventListener('resize', this._onResize);
  },


  /**
   * Renders component
   * @returns {Object} React element
   */
  render() {
    const className = 'component-emoji-rotator';

    return (
      <div ref='rotatorContainer' className={className} />
    );
  },


  /**
   * Animates an emoji in
   * @returns {undefined} undefined
   */
  _setup() {
    this._addEmojis();
    this._changeEmojis();

    this.changeInterval = setInterval(this._changeEmojis, 3000);
  },


  /**
   * Resize handler
   * @returns {undefined} undefined
   */
  _onResize() {
    this._removeContent();

    this.resetTimeout = setTimeout(() => {
      this._setup();
    }, 200);
  },


  /**
   * Changes the emojis
   * @returns {undefined} undefined
   */
  _addEmojis() {
    const approximateEmojiWidth = !this.props.large ? 30 : 50;
    const approximateEmojiHeight = !this.props.large ? 30 : 50;
    const fontSize = !this.props.large ? 24 : 42;
    let colCount = 0;
    let rowCount = 0;
    const totalCols = Math.floor(window.innerWidth / approximateEmojiWidth);
    const totalRows = Math.floor(window.innerHeight / approximateEmojiHeight);
    const emojiWidth = window.innerWidth / totalCols;
    const emojiHeight = window.innerHeight / totalRows;
    const totalCount = totalCols * totalRows;

    this.emojiObjects = [];

    for (let i = 0; i < totalCount; i++) {
      const emojiContainer = new PIXI.Container();
      renderHelper.stage.addChild(emojiContainer);
      emojiContainer.x = (colCount * emojiWidth) + (emojiWidth * 0.5);
      emojiContainer.y = (rowCount * emojiHeight) + (emojiHeight * 0.5);
      emojiContainer._emojiIteration = 0;

      const emojiText = new PIXI.Text(this.emojis[0],
        {
          font: fontSize + 'px Helvetica',
          fill: 0xFFFFFF,
          align: 'center',
        }
      );
      emojiText.resolution = 2;
      emojiText.x = -(emojiWidth * 0.4);
      emojiText.y = -(emojiHeight * 0.4);

      emojiContainer.addChild(emojiText);
      emojiContainer._emojiText = emojiText;

      colCount++;
      if (colCount === totalCols) {
        colCount = 0;
        rowCount++;
      }

      this.emojiObjects.push(emojiContainer);
    }
  },


  /**
   * Animates an emoji out
   * @returns {undefined} undefined
   */
  _changeEmojis() {
    const _this = this;

    if (!this.props.paused) {
      for (let i = 0; i < this.emojiObjects.length; i++) {
        // const timeout = Math.random() * 5000;
        const timeout = (i * 10);

        setTimeout(() => {
          if (!_this.props.paused) {
            _this._animateEmojiOut(this.emojiObjects[i]);
          }
        }, timeout);

        setTimeout(() => {
          if (!_this.props.paused) {
            _this._animateEmojiIn(this.emojiObjects[i]);
          }
        }, timeout + 100);
      }
    } else {
      clearInterval(this.changeInterval);
    }
  },


  /**
   * Animates an emoji out
   * @returns {undefined} undefined
   */
  _animateEmojiOut(object) {
    if (object) {
      let newIteration = object._emojiIteration + 1;
      if (newIteration > this.emojis.length - 1) {
        newIteration = 0;
      }

      object._emojiIteration = newIteration;

      this.tween = window.TweenLite.to(
        object.scale,
        0.1,
        {
          x: 0,
          y: 0,
          ease: window.Linear.easeNone,
        }
      );
    }
  },


  /**
   * Animates an emoji in
   * @returns {undefined} undefined
   */
  _animateEmojiIn(object) {
    if (object) {
      object._emojiText.text = this.emojis[object._emojiIteration];

      this.tween = window.TweenLite.to(
        object.scale,
        0.1,
        {
          x: 1,
          y: 1,
          ease: window.Linear.easeNone,
        }
      );
    }
  },


  /**
   * Removes all emojis and stops all animations
   * @returns {undefined} undefined
   */
  _removeContent() {
    clearInterval(this.changeInterval);
    clearTimeout(this.resetTimeout);

    if (this.tween) {
      this.tween.kill();
      this.tween = null;
    }

    for (let i = 0; i < this.emojiObjects.length; i++) {
      window.TweenLite.killTweensOf(this.emojiObjects[i]);
      renderHelper.stage.removeChild(this.emojiObjects[i]);
    }

    this.emojiObjects = [];
  },
});

export default EmojiRotator;



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/EmojiRotator.jsx
 **/